const IgoLockedArtwork = {
  escape(value) { return String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c])); },
  render(p, uid, label = '') {
    const e=this.escape, detail=p.presentation==='detail', placement=p.placement || {};
    const vw=detail?1000:1024, vh=detail?1000:1536;
    const scale=Math.min((detail?850:placement.width || 390)/p.width,(detail?850:placement.height || 465)/p.height);
    const width=p.width*scale, height=p.height*scale;
    const x=(detail?500:placement.centerX || 512)-width/2;
    const y=detail?(1000-height)/2:placement.top || 600;
    const background=detail?`<rect width="1000" height="1000" fill="${e(p.background || '#eee9df')}"/>`:`<image href="${e(p.base)}" width="1024" height="1536" preserveAspectRatio="${e(p.baseFit || 'xMidYMid meet')}"/>`;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${vw} ${vh}" width="${vw}" height="${vh}" role="img" aria-label="${e(label)}" class="igo-locked-artwork">${background}<image href="${e(p.image)}" x="${x}" y="${y}" width="${width}" height="${height}" preserveAspectRatio="xMidYMid meet"/></svg>`;
  }
};
if(typeof window!=='undefined')window.IgoLockedArtwork=IgoLockedArtwork;
if(typeof module!=='undefined')module.exports=IgoLockedArtwork;

let igoGallerySerial = 0;
class IgoApparelGallery extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.uid = `igo-gallery-${++igoGallerySerial}`;
    this.data = JSON.parse(this.querySelector('[data-gallery-data]').textContent);
    this.labels = JSON.parse(this.querySelector('[data-gallery-labels]').textContent);
    this.anchor = this.querySelector('.igo-apparel-zoom');
    this.thumbs = this.querySelector('[data-thumbnails]');
    this.anchor.addEventListener('click', event => {
      if (!this.currentView?.composition) return;
      event.preventDefault(); this.openZoom();
    }, {signal:this.controller.signal});
    document.addEventListener('variant:change', event => {
      if (event.target.getAttribute('id') !== this.dataset.form) return;
      const variant = event.detail.variant;
      if (!variant?.id) {
        this.group = {views:[]}; this.currentView = null;
        this.anchor.replaceChildren(); this.anchor.removeAttribute('href');
        this.thumbs.replaceChildren(); this.anchor.hidden = true; this.thumbs.hidden = true;
        this.querySelector('[data-selection]').textContent = this.labels.choose;
        this.querySelector('[data-image-kind]').textContent = '';
        return;
      }
      this.anchor.hidden = false;
      this.querySelector('[data-selection]').textContent = variant.title;
      this.update(String(variant.id));
    }, {signal:this.controller.signal});
    this.update(this.dataset.selected);
  }
  disconnectedCallback() {
    this.controller?.abort(); this.controller = null;
    this.dialog?.close(); this.dialog?.remove(); this.dialog = null;
  }
  update(id) {
    const key = this.data.variants[id];
    const group = this.data.groups[key];
    if (!group) {
      this.group = {views:[]}; this.currentView = null;
      this.anchor.removeAttribute('aria-haspopup');
      this.thumbs.replaceChildren(); this.thumbs.hidden = true;
      this.anchor.removeAttribute('target'); this.anchor.removeAttribute('href');
      const message = document.createElement('span');
      message.className = 'igo-apparel-preview-pending'; message.textContent = this.labels.unavailable;
      this.anchor.replaceChildren(message);
      this.querySelector('[data-image-kind]').textContent = this.labels.unavailable;
      return;
    }
    this.group = group; this.thumbs.replaceChildren();
    group.views.forEach((view, index) => {
      const button = document.createElement('button'); button.type = 'button';
      button.setAttribute('aria-label', this.labels[view.kind] || this.labels.detail);
      if (view.composition) {
        button.innerHTML = IgoLockedArtwork.render({...this.data.lockedArtwork,...view.composition},`${this.uid}-thumb-${index}`,'');
        button.querySelector('svg').setAttribute('aria-hidden','true');
      } else {
        const image = document.createElement('img');
        image.src = this.url(view.src,160); image.alt = ''; image.width=80; image.height=100; image.loading='lazy'; button.append(image);
      }
      button.addEventListener('click', () => this.show(index), {signal:this.controller.signal});
      this.thumbs.append(button);
    });
    this.thumbs.hidden = group.views.length < 2; this.show(0);
  }
  url(src, width) { const url = new URL(src, location.origin); url.searchParams.set('width',width); return url.href; }
  show(index) {
    const view = this.group.views[index]; if(!view)return;
    this.currentView = view;
    this.currentLabel = `${this.data.title} — ${this.querySelector('[data-selection]').textContent} — ${this.labels[view.kind] || this.labels.detail}`;
    if(view.composition){
      this.anchor.innerHTML = IgoLockedArtwork.render({...this.data.lockedArtwork,...view.composition},`${this.uid}-main`,this.currentLabel);
      this.anchor.removeAttribute('target'); this.anchor.href='#'; this.anchor.setAttribute('aria-haspopup','dialog');
    }else{
      const image = document.createElement('img'); image.className='igo-apparel-main-image';
      image.src=this.url(view.src,1200); image.srcset=[400,600,800,1000,1200].map(w=>`${this.url(view.src,w)} ${w}w`).join(',');
      image.sizes='(min-width: 1000px) 50vw, 100vw'; image.alt=this.currentLabel; image.width=1200; image.height=1400;
      this.anchor.replaceChildren(image); this.anchor.setAttribute('target','_blank'); this.anchor.removeAttribute('aria-haspopup');
      this.anchor.href=this.url(view.src,2000);
    }
    this.querySelector('[data-image-kind]').textContent=this.labels[view.kind] || this.labels.detail;
    this.dataset.kind=view.kind;
    [...this.thumbs.children].forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
  }
  openZoom(){
    this.dialog?.remove();
    const dialog=document.createElement('dialog'); dialog.className='igo-apparel-zoom-dialog';
    dialog.setAttribute('aria-label',this.currentLabel);
    const close=document.createElement('button'); close.type='button'; close.textContent=this.labels.close;
    close.addEventListener('click',()=>dialog.close());
    dialog.innerHTML=IgoLockedArtwork.render({...this.data.lockedArtwork,...this.currentView.composition},`${this.uid}-zoom`,this.currentLabel);
    dialog.append(close); document.body.append(dialog); this.dialog=dialog;
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    dialog.showModal();
  }
}
if (!customElements.get('igo-apparel-gallery')) customElements.define('igo-apparel-gallery',IgoApparelGallery);

class IgoFamilyPicker extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;
    this.ready=true;
    this.variants=JSON.parse(this.querySelector('[data-family-variants]').textContent);
    this.labels=JSON.parse(this.querySelector('[data-family-labels]').textContent);
    this.selected=this.variants.find(v=>String(v.id)===this.dataset.selected);
    if(!this.selected)return;
    this.render();
    this.dataset.ready='true';
  }
  render(){
    const options=this.querySelector('[data-family-options]');options.replaceChildren();
    for(const key of ['garment','color','size']){
      const pool=this.variants.filter(v=>(key==='garment'||v.garment===this.selected.garment)&&(key!=='size'||v.color===this.selected.color));
      const field=document.createElement('fieldset'),legend=document.createElement('legend'),values=document.createElement('div');
      legend.textContent=this.labels[key]+': '+this.selected[key];field.append(legend);values.className='igo-family-values';
      for(const value of [...new Set(pool.map(v=>v[key]))]){
        const button=document.createElement('button');button.type='button';button.textContent=value;button.dataset.familyKey=key;button.setAttribute('aria-pressed',String(value===this.selected[key]));
        button.addEventListener('click',()=>this.choose(key,value));values.append(button);
      }
      field.append(values);options.append(field);
    }
  }
  async choose(key,value){
    if(this.busy||value===this.selected[key])return;
    const old=this.selected;
    let candidates=this.variants.filter(v=>v[key]===value);
    if(key!=='garment')candidates=candidates.filter(v=>v.garment===old.garment);
    if(key==='size')candidates=candidates.filter(v=>v.color===old.color);
    const target=candidates.find(v=>v.size===old.size&&v.color===old.color)||candidates.find(v=>v.size===old.size&&v.available)||candidates.find(v=>v.size===old.size)||candidates.find(v=>v.available)||candidates[0];
    if(!target)return;
    this.busy=true;this.setAttribute('aria-busy','true');
    this.querySelector('[data-family-status]').textContent=this.labels.loading;
    this.querySelectorAll('button').forEach(b=>b.disabled=true);
    const section=this.closest('.shopify-section');
    const buy=section.querySelector('button[type="submit"]');if(buy)buy.disabled=true;
    try{
      const url=new URL(target.url,location.origin);url.searchParams.set('section_id',this.dataset.section);
      const response=await fetch(url.href);if(!response.ok)throw new Error('Selection request failed');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const replacement=doc.getElementById(section.id);
      if(!replacement?.querySelector('igo-family-picker'))throw new Error('Missing product section');
      const quantity=section.querySelector('input[name="quantity"]')?.value;
      if(quantity){const input=replacement.querySelector('input[name="quantity"]');if(input)input.value=quantity;}
      const pageUrl=new URL(target.url,location.origin);history.replaceState({},'',pageUrl.href);
      section.replaceWith(replacement);
      const newPicker=replacement.querySelector('igo-family-picker');
      newPicker.querySelectorAll('button').forEach(button=>{if(button.dataset.familyKey===key&&button.textContent===value)button.focus({preventScroll:true});});
      window.Shopify?.PaymentButton?.init();
    }catch(error){
      this.busy=false;this.removeAttribute('aria-busy');this.querySelectorAll('button').forEach(b=>b.disabled=false);
      if(buy)buy.disabled=!old.available;
      this.querySelector('[data-family-status]').textContent=this.labels.error;
    }
  }
}
if(!customElements.get('igo-family-picker'))customElements.define('igo-family-picker',IgoFamilyPicker);
